import { render, staticRenderFns } from "./JournalLpo__toolbar.vue?vue&type=template&id=20694f76&scoped=true&"
import script from "./JournalLpo__toolbar.vue?vue&type=script&lang=js&"
export * from "./JournalLpo__toolbar.vue?vue&type=script&lang=js&"
import style0 from "./JournalLpo__toolbar.vue?vue&type=style&index=0&id=20694f76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20694f76",
  null
  
)

export default component.exports